export class SubmissionSearchObject {
  constructor(
    public submissionIdentifier?: string,
    public submissionIdentifierType?: string,
    public hasNote?: string,
    public status?: string,
    public startDate?: string,
    public endDate?: string,
    public reportingCenter?: string,
    public projectName?: string,
    public testType?: string
  ) {}
}

export class SampleSearchObject {
  constructor(
    public sampleId?: string,
    public status?: string,
    public startDate?: string,
    public endDate?: string,
    public testType?: string,
    public locus?: string,
    public reportingCenter?: string,
    public projectName?: string,
    public centerCode?: string,
  ) {}
}

export class SubmissionSearchUserInfoObject {
  constructor(
    public internalUser?: boolean,
    public status?: string[],
    public reportingCenter?: string[],
    public projectName?: string[],
    public testType?: string[],
    public loci?: string[],
    public centerCode?: string[],
  ) {}
}
